<div class="tag-wrapper">
  <span class="tag-item" *ngFor="let tag of tags" (click)="onClick(tag)"
    [ngClass]="{active:isTagActive(tag),disabled:tag.disabled}" >
    <ng-container *ngTemplateOutlet="tagTemplate||defaultTag;context:{$implicit:tag,active:isTagActive(tag)}"></ng-container>
  </span>
</div>

<ng-template #defaultTag let-tagItem>
  <span>{{tagItem.title}}</span>
</ng-template>
